// https://date-fns.org/docs/format
import format from 'date-fns/format'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import { parseStringToDateTime } from '@utils/parse-string-to-date'

import store from '@state/store'
import { zhTW, enUS } from 'date-fns/locale'

const localeMap = {
  'zh-Hant': zhTW,
  en: enUS,
}

export default function formatDate(date, pattern = 'date') {
  if (!(date instanceof Date)) {
    date = parseStringToDateTime(date)
  }

  const patterMap = {
    date: 'yyyy-MM-dd', // '2019-06-13'
    dateTime: 'yyyy-MM-dd HH:mm', // 2019-01-01 00:00
    dateTimeSecond: 'yyyy-MM-dd HH:mm:ss', // 2019-01-01 00:00:00
    dateWeekDay: 'yyyy/M/d EEE', // '2019/6/13 週三'
    dateTimeWeekDay: 'yyyy/M/d EEE HH:mm', // '2019/6/13 週三 00:00'
    time: 'HH:mm', // '13:30'
  };

  return format(date, patterMap[pattern], {
    locale: localeMap[store.state.set.cachedLanguage],
  })
}

export function timeDiffInMinutes(startTime, endTime) {
  const startDate = parseStringToDateTime(`2018-01-01 ${startTime}`)
  const endDate = parseStringToDateTime(`2018-01-01 ${endTime}`)

  return differenceInMinutes(endDate, startDate)
}

export function dateDiffInMinutes(startDate, endDate) {
  startDate = parseStringToDateTime(startDate)
  endDate = parseStringToDateTime(endDate)

  return differenceInMinutes(endDate, startDate)
}
